import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

const STATUSES = [
  { key: "pending", label: "Bekliyor", color: "bg-amber-100 text-amber-700 border-amber-200" },
  { key: "in_progress", label: "İlgileniliyor", color: "bg-blue-100 text-blue-700 border-blue-200" },
  { key: "completed", label: "Tamamlandı", color: "bg-green-100 text-green-700 border-green-200" },
];

const ServiceCalls = () => {
  const [calls, setCalls] = useState([]);
  const load = useCallback(() => api.get("/service-calls").then((r) => setCalls(r.data)), []);
  useEffect(() => {
    load();
    const i = setInterval(load, 10000);
    return () => clearInterval(i);
  }, [load]);

  const update = async (id, status) => {
    await api.put(`/service-calls/${id}`, { status });
    toast.success("Güncellendi"); load();
  };

  const del = async (id) => {
    await api.delete(`/service-calls/${id}`); load();
  };

  return (
    <div className="space-y-6" data-testid="calls-page">
      <header>
        <h1 className="font-serif text-3xl text-zbeach-dark">Garson Çağrıları</h1>
        <p className="text-zbeach-muted text-sm mt-1">Aktif çağrıları takip edin ve yönetin.</p>
      </header>

      <div className="grid lg:grid-cols-3 gap-4">
        {STATUSES.map((s) => {
          const items = calls.filter((c) => c.status === s.key);
          return (
            <div key={s.key} className={`rounded-2xl border-2 p-4 ${s.color}`}>
              <h3 className="font-serif text-lg mb-3 flex items-center justify-between">
                {s.label} <span className="text-sm font-medium">{items.length}</span>
              </h3>
              <div className="space-y-2">
                {items.length === 0 && <div className="text-xs text-zbeach-muted">—</div>}
                {items.map((c) => (
                  <div key={c.id} className="bg-zbeach-surface rounded-xl p-3" data-testid={`call-card-${c.id}`}>
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="font-medium text-zbeach-dark">{c.areaName}</div>
                        <div className="text-[11px] text-zbeach-muted">{new Date(c.createdAt).toLocaleString("tr-TR")}</div>
                        {c.note && <div className="text-xs text-zbeach-muted mt-1 italic">"{c.note}"</div>}
                      </div>
                      <button onClick={() => del(c.id)} className="text-red-500 text-xs"><i className="fa-solid fa-trash" /></button>
                    </div>
                    <div className="flex gap-1.5 mt-2">
                      {s.key !== "in_progress" && <button onClick={() => update(c.id, "in_progress")} className="text-[11px] px-2 py-1 rounded-full bg-blue-600 text-white">İlgileniliyor</button>}
                      {s.key !== "completed" && <button onClick={() => update(c.id, "completed")} className="text-[11px] px-2 py-1 rounded-full bg-green-600 text-white">Tamamlandı</button>}
                      {s.key !== "pending" && <button onClick={() => update(c.id, "pending")} className="text-[11px] px-2 py-1 rounded-full bg-amber-600 text-white">Beklemede</button>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ServiceCalls;
